import { FunctionComponent, useContext } from 'react';

import type { ForwardProps } from '../../types';
import Flex from '../Flex';

import MenuContext from './Menu.context';
import { StyledMenuGroupHeader, StyledMenuGroupList } from './Menu.styles';
import type { MenuGroupProps } from './Menu.types';
import MenuItem from './MenuItem';

const MenuGroup: FunctionComponent<MenuGroupProps & ForwardProps> = ({
  id,
  label,
  items
}: MenuGroupProps & ForwardProps) => {
  const { componentId } = useContext(MenuContext);

  const groupId = `${componentId}-${id}`;
  return (
    <li>
      <Flex
        container={{ alignItems: 'center', pad: [0.5, 1] }}
        as={StyledMenuGroupHeader}
        id={groupId}
      >
        {label}
      </Flex>
      <StyledMenuGroupList role='group' aria-labelledby={`#${groupId}`}>
        {items.length > 0 &&
          items.map(item => {
            return <MenuItem {...item} key={item.id} />;
          })}
      </StyledMenuGroupList>
    </li>
  );
};

export default MenuGroup;
